export class CnaeSearch {
    id: string;
    name: string;
    sapItemCode: string;
    types: number[];
    status: string[];
    skip: number = 0;
    limit: number = 10;
    totalItems: number = 0;
    allItems: Boolean = false;
}



// WEBPACK FOOTER //
// ./src/app/models/CnaeSearch.model.ts